import React, { ChangeEvent } from "react";
import { Typeahead } from "react-bootstrap-typeahead";

interface TypeaheadProps {
  clearButton?: boolean;
  className?: string;
  id?: string;
  options: any;
  placeholder?: string;
  selected?: any;
  onChange: any;
  onInputChange?: (text: string, e: ChangeEvent<HTMLInputElement>) => void;
  maxHeight?: string;
  emptyLabel?: string;
  disabled?: boolean;
}

const TypeAheadReuseable = ({
  options,
  placeholder,
  selected,
  onChange,
  clearButton,
  emptyLabel,
  maxHeight,
  className,
  id,
  disabled,
  onInputChange,
}: TypeaheadProps) => {
  try {
    return (
      <Typeahead
        options={options}
        onChange={onChange}
        onInputChange={onInputChange}
        placeholder={placeholder}
        selected={selected}
        maxHeight={maxHeight}
        id={id}
        clearButton={clearButton}
        emptyLabel={emptyLabel}
        className={className}
        inputProps={{
          style: { fontSize: 16 },
        }}
        disabled={disabled}
      />
    );
  } catch (error) {
    console.error("An error occurred in the Typeahead component:", error);
    return null;
  }
};

export default TypeAheadReuseable;
